"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PollCreator = require("./PollCreator.style");

var _DarkButton = _interopRequireDefault(require("../../../Button/DarkButton"));

var _DarkBoxInput = _interopRequireDefault(require("../../../Input/DarkBoxInput"));

var _AccentButton = _interopRequireDefault(require("../../../Button/AccentButton"));

var PollCreator =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PollCreator, _PureComponent);

  function PollCreator(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PollCreator);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PollCreator).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onOptionTextChange", function (optionId, optionText) {
      _this.updateOption(optionId, null, optionText);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updateOption", function (optionId, imageUrl, optionText) {
      var updatedOptions = _this.state.poll.options.map(function (option) {
        if (option.optionId === optionId) {
          option.imageUrl = imageUrl || option.imageUrl || '';
          option.optionText = optionText || option.optionText;
        }

        return option;
      });

      _this.setState({
        poll: (0, _objectSpread2.default)({}, _this.state.poll, {
          options: updatedOptions
        })
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onAddImage", function (optionId) {
      window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz'); // this.context.showLoading();

      window.fs_filepicker.picker({
        fromSources: ['local_file_system', 'url', 'imagesearch', 'facebook', 'instagram', 'googledrive', 'dropbox', 'github', 'gmail', 'webcam'],
        maxFiles: 1,
        minFiles: 1,
        accept: ['image/*'],
        onOpen: function onOpen() {// this.context.hideLoading();
        },
        onFileUploadFailed: function onFileUploadFailed(file, error) {
          window.analytics.track('FILEPICKER_FILE_UPLOAD_FAILED', {
            pollId: _this.state.poll.pollId,
            liveClassId: _this.state.poll.liveClassId,
            error: error
          });
        },
        onFileUploadFinished: function onFileUploadFinished(data) {
          window.analytics.track('FILEPICKER_FILE_UPLOAD_FINISHED', {
            pollId: _this.state.poll.pollId,
            liveClassId: _this.state.poll.liveClassId,
            fileUploadData: JSON.stringify(data),
            fileUrl: data.url
          });

          _this.updateOption(optionId, data.url);
        }
      }).open();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onRemoveImage", function (optionId) {
      _this.updateOption(optionId, '');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onRemoveOption", function (optionId) {
      _this.state.poll.options = _this.state.poll.options.filter(function (option) {
        return option.optionId !== optionId;
      });

      _this.setState({});
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderOneOption", function (option) {
      var imageUrl = option.imageUrl;
      return _react.default.createElement("div", {
        key: option.id || option.optionId,
        className: "single-option-wrapper",
        style: !imageUrl ? {
          padding: 0
        } : {}
      }, !imageUrl && _react.default.createElement(_AccentButton.default, {
        onClick: function onClick() {
          return _this.onAddImage(option.optionId);
        },
        icon: {
          type: 'image',
          className: 'image-upload-button'
        }
      }), imageUrl && _react.default.createElement("div", {
        className: "image-container"
      }, _react.default.createElement("img", {
        src: option.imageUrl,
        alt: option.optionText,
        className: "option-image"
      }), _react.default.createElement("div", {
        className: "image-hoover"
      }, _react.default.createElement("div", {
        className: "image-buttons"
      }, _react.default.createElement(_AccentButton.default, {
        onClick: function onClick() {
          return _this.onAddImage(option.optionId);
        },
        icon: {
          type: 'edit',
          className: 'image-hoover-icon',
          style: {
            width: '13px',
            height: '13px',
            margin: '0 16px'
          }
        }
      }), _react.default.createElement(_AccentButton.default, {
        onClick: function onClick() {
          return _this.onRemoveImage(option.optionId);
        },
        icon: {
          type: 'delete',
          className: 'image-hoover-icon',
          style: {
            width: '13px',
            height: '13px',
            marginRight: '16px'
          }
        }
      })))), _react.default.createElement(_DarkBoxInput.default, {
        placeholder: "Option",
        value: option.optionText,
        className: "override-option-input",
        onChange: function onChange(event) {
          return _this.onOptionTextChange(option.optionId, event.target.value);
        }
      }), _react.default.createElement(_AccentButton.default, {
        onClick: function onClick() {
          return _this.onRemoveOption(option.optionId);
        },
        icon: {
          type: 'close',
          style: {
            width: '18px',
            marginRight: '6px'
          }
        }
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onAddOption", function () {
      var poll = (0, _objectSpread2.default)({}, _this.state.poll, {
        options: (_this.state.poll.options || []).concat([{
          optionId: (0, _v.default)()
        }])
      });

      _this.setState({
        poll: poll
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onCancelHandler", function (event) {
      event.preventDefault();

      _this.props.onCancel();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onSaveHandler", function (event) {
      event.preventDefault();

      _this.props.onSave(_this.state.poll);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMakeLiveHandler", function (event) {
      event.preventDefault();

      _this.props.onMakeLive(_this.state.poll);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderButtons", function () {
      var poll = _this.state.poll;

      if (!poll.isLive) {
        return _react.default.createElement("div", {
          className: "buttons-wrapper"
        }, _react.default.createElement(_DarkButton.default.SecondaryButton, {
          className: "cancel-button",
          onClick: _this.onCancelHandler
        }, "Cancel"), _react.default.createElement(_DarkButton.default, {
          className: "save-button",
          onClick: _this.onSaveHandler
        }, "Save"), _react.default.createElement(_DarkButton.default, {
          className: "make-live-button",
          onClick: _this.onMakeLiveHandler
        }, "Make Live"));
      }

      return '';
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onQuestionTextChange", function (questionText) {
      _this.setState({
        poll: (0, _objectSpread2.default)({}, _this.state.poll, {
          questionText: questionText
        })
      });
    });
    _this.state = {
      poll: _this.props.poll
    };
    return _this;
  }

  (0, _createClass2.default)(PollCreator, [{
    key: "renderOptions",
    value: function renderOptions() {
      var _this$state$poll = this.state.poll,
          _this$state$poll$opti = _this$state$poll.options,
          options = _this$state$poll$opti === void 0 ? [] : _this$state$poll$opti,
          isLive = _this$state$poll.isLive;

      if (!isLive) {
        return _react.default.createElement("div", {
          className: "options-wrapper"
        }, options.map(this.renderOneOption), _react.default.createElement(_AccentButton.default, {
          onClick: this.onAddOption,
          text: "Add Option",
          icon: {
            type: 'add',
            className: 'add-option-button-icon',
            style: {
              width: '18px',
              marginRight: '6px'
            }
          },
          className: "add-option-button"
        }));
      }

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className;
      var poll = this.state.poll;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_PollCreator.PollCreatorWrapper, className)
      }, _react.default.createElement(_DarkBoxInput.default, {
        placeholder: "Enter your question here",
        value: poll.questionText,
        className: "override-question-input",
        onChange: function onChange(event) {
          return _this2.onQuestionTextChange(event.target.value);
        }
      }), this.renderOptions(), this.renderButtons());
    }
  }]);
  return PollCreator;
}(_react.PureComponent);

PollCreator.defaultProps = {
  className: '',
  onMakeLive: function onMakeLive() {
    return null;
  },
  onSave: function onSave() {
    return null;
  },
  onCancel: function onCancel() {
    return null;
  }
};
PollCreator.propTypes = {
  className: _propTypes.default.string,
  poll: _propTypes.default.object.isRequired,
  onSave: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  onMakeLive: _propTypes.default.func
};
var _default = PollCreator;
exports.default = _default;